import { Button, Flex, Spinner, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const BidSelectionSaveStatus = ({
  hasPendingChanges,
  lastSavedLabel,
  onSaveNow,
  isSaving,
}: {
  hasPendingChanges: boolean;
  lastSavedLabel: string | null;
  onSaveNow: () => void;
  isSaving: boolean;
}) => {
  const { t } = useTranslation();

  const hasContent = hasPendingChanges || !!lastSavedLabel;

  return (
    <Flex
      justifyContent="flex-end"
      alignItems="center"
      gap="2"
      px="4"
      minH="8"
      visibility={hasContent ? "visible" : "hidden"}
    >
      {isSaving && <Spinner size="xs" color="smPrimary" />}
      <Text fontSize="xs" color={"smMuted"}>
        {hasPendingChanges ? t("Unsaved changes") : (lastSavedLabel ?? "\u00A0")}
      </Text>
      {hasPendingChanges && !isSaving && (
        <Button size="xs" colorScheme="teal" variant="ghost" onClick={onSaveNow}>
          {t("Save now")}
        </Button>
      )}
    </Flex>
  );
};
